/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, ElementRef, Input, SimpleChanges, OnChanges, OnInit, HostListener } from '@angular/core';
import { CommonService } from './services/common.service';

@Component({
    selector: 'warning-message',
    template: `
    <p class="callidus-required-err">
        <span class="fa fa-exclamation-circle" aria-hidden="true"></span>
        <span class="sr-only">{{ getTranslationWithKey('error') }}:</span>{{ getTranslationWithKey('common_req_err_message') }}({{ getTranslationWithKey('denoted_in_red') }})
    </p>
    `,
    styles:[
        ` .callidus-required-err{
            margin: 0;
            padding: 0.6rem;
            margin-top: 3.05rem;
            color: #d0021b;
            border-radius: 3px;
            background-color: #fdf3f4;
            border: solid 1px #d0021b;
            text-align: center;
          }
        `
    ]
})
export class WarnignMessageComponent implements OnInit {

//   @Input() saveOperation: boolean;
//   @Input() resetButton: boolean;

  constructor(private el: ElementRef,private commonService: CommonService,) {
  }

//   @HostListener('click') onclick() {
//     this.buttonClicked('<i class="fa fa-spinner"></i>');
//   }

  ngOnInit() {}

  public getTranslationWithKey(key: string): string {
    return this.commonService.getTranslatedVal(key);
  }

//   ngOnChanges(changes: SimpleChanges) {
//     if (changes.saveOperation && changes.saveOperation.currentValue) {
//       this.buttonClicked('<i class="fa fa-check-circle"></i>');
//     } else {
//       this.buttonClicked('Save');
//     }

//     if (changes.resetButton) {
//       if (this.el.nativeElement.innerHTML === '<i class="fa fa-spinner"></i>') {
//         this.buttonClicked('Save');
//       }

//     }
//   }

//   private buttonClicked(content) {
//     this.el.nativeElement.innerHTML = content;

//     /* We will handle this use case in a different way. 
//     *  The below solution is a breaking change for al existing pages.
//     *  So commenting it out for the time being
//     */

//     /*if (content !== 'Save') {
//       this.el.nativeElement.disabled = true;
//     }*/
//   }

}
